<template>
    <div class="solution">
        <div class="title">DATASERVICE</div>
        <div class="title">数据服务</div>
        <div class="card">
            <el-row>
                <el-col
                        v-for="(o, index) in service"
                        :key="o"
                        :span= 6
                        :offset="index > 0 ? 2 : 1"
                >
                    <div class="service-card">
                        <div class="service-title">{{o.title}}</div>
                        <div class="service-text">{{o.text}}</div>
                        <div class="service-btn">
                            <div style="cursor: pointer">立即申请</div>
                            <div>|</div>
                            <div style="cursor: pointer">应用管理</div>
                            <div>|</div>
                            <div style="cursor: pointer">技术文档</div>
                        </div>

                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
  name: "DataService",
  data() {
    return {
      service: [
        {
          title: '热点网格服务',
          text: '全国污染热点网格服务接口',
          serveBtn: ['立即申请', '应用管理', '技术文档']
        }, {
          title: '风险预警服务',
          text: '高污染风险预警和建议措施接口',
          serveBtn: ['', '', '']
        }, {
          title: '自定义查询接口',
          text: '允许用户根据特定需求定制数据查询接口',
          serveBtn: ['', '', '']
        }
      ],
    };
  }
}
</script>

<style scoped>
.solution {
    padding: 40px 0;
    background-color: rgba(187, 187, 187, 0.17);
}
.title {
    text-align: left;
    margin-bottom: 10px;
    margin-left: 120px;
    font-size: 50px;
}
.card {
    margin-top: 40px;
    padding: 20px 100px;
    .service-card {
        border-radius: 8px;
        background-color: white;
        border: 1px solid rgba(187, 187, 187);
        .service-title {

            padding: 20px 30px;
            font-size: 35px;
            text-align: left;
        }
        .service-text {
            font-size: 25px;
            color: rgba(16, 16, 16, 0.38);
        }
        .service-btn {
            border: 0px solid rgba(187, 187, 187);
            border-radius: 0 0 8px 8px;
            padding: 0 10%;
            margin-top: 40px;
            height: 50px;
            line-height: 50px;
            background-color: rgba(229, 229, 229, 1);
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>